import React from 'react'

const RecordRow = (props) => {
  return (
    <div className="flex items-center gap-5 p-3 rounded-lg hover:bg-slate-50">
        <div className="w-1/5">{props.data.date}</div>
        <div className="w-1/3">{props.data.content}</div>
        <div className="w-1/3">{props.data.user}</div>
        <div>{props.data.score}</div>
    </div>
  )
}

export default RecordRow